<template>
  <div class="page test-page">
    <curtains>
      <fixed-blocks v-if="this.$mq !== 'mobile'"></fixed-blocks>

      <fixed-blocks-mobile v-if="this.$mq === 'mobile'">
        <navigation></navigation>
      </fixed-blocks-mobile>

      <div class="prevQuestionLink" @click="prevQuestion" v-show="current >1 && state==='test'">Назад</div>
      <div class="questions" v-show="state==='test'">
        <navigation v-if="this.$mq !== 'mobile'"></navigation>
        <div class="block image-block">
          <transition name="slide-right" v-for="question in questions">
            <div class="image-container" v-show="current === question.index">
              <img :src="question.image" alt="">
            </div>
          </transition>
        </div>
        <div class="block text-block">
          <div class="counter">
            <span class="number active">{{current}}</span>
            <div class="c_line"></div>
            <span class="number">10</span>
          </div>
          <transition name="slide-left" v-for="question in questions">
            <div class="question" v-show="current === question.index">
              <h3 class="title">{{question.text}}</h3>
              <div class="answers">
                <label class="answer" v-for="answer in question.variants">
                  <span class="text">{{answer.text}}</span>
                  <input type="radio" :name="question.index+'_'+answer.score" v-model="question.score"
                         @change="nextQuestion"
                         :value="answer.score">
                  <span class="checkmark"></span>
                </label>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div class="questions" v-show="state==='result'">
        <navigation v-if="this.$mq !== 'mobile'"></navigation>
        <div class="block image-block">
          <transition name="slide-right" v-for="result in results">
            <div class="image-container" v-show="resultIndex === result.index">
              <img :src="result.image" alt="">
            </div>
          </transition>
        </div>
        <div class="block text-block">
          <transition name="slide-left" v-for="result in results">
            <div class="result" v-show="resultIndex === result.index">

              <router-link to="/" v-if="$mq !=='mobile'">На главную</router-link>

              <h3 class="title">{{result.title}}</h3>
              <p class="text">{{result.text}}</p>
              <p class="text"><strong>#отФУДбольИзжогу</strong> вместе с Гевискон<sup>®</sup>.
                Не важно, какой ты болельщик, отфутболь изжогу и болей за любимую команду на 100%.
                Выкладывай фото с хэштегами <strong>#отФУДбольизжогу</strong> и <strong>#Гевискон</strong> и получи
                возможность выиграть гастротур в Бразилию. </p>
              <div class="share-result">
                <div class="text">Поделись результатом:</div>
                <div class="shares-links">
                  <social-sharing :url="'http://gaviscon.afisha.ru/result'+result.index+'.html'"
                                  :title="result.shareTitle"
                                  :description="result.shareText"
                                  :quote="result.shareText"
                                  hashtags="ОтФУДбольизжогу,гевискон"
                                  v-cloak inline-template>
                    <div class="share-links">
                      <div class="share-item" @click="$ga.event('Шаринг', 'Шаринг вконтакте', 1)">
                        <network network="vk" id="vk">
                          <i class="icon icon-vk"></i>
                        </network>
                      </div>
                      <div class="share-item" @click="$ga.event('Шаринг', 'Шаринг facebook', 1)">
                        <network network="facebook" id="facebook">
                          <i class="icon icon-facebook"></i>
                        </network>
                      </div>
                      <div class="share-item" @click="$ga.event('Шаринг', 'Шаринг twitter', 1)">
                        <network network="twitter" id="twitter">
                          <i class="icon icon-twitter"></i>
                        </network>
                      </div>
                      <div class="share-item" @click="$ga.event('Шаринг', 'Шаринг одноклассники', 1)">
                        <network network="odnoklassniki" id="odnoklassniki">
                          <i class="icon icon-odnoklassniki"></i>
                        </network>
                      </div>
                    </div>
                  </social-sharing>
                </div>
              </div>

              <router-link to="/" v-if="$mq ==='mobile'">На главную</router-link>


            </div>
          </transition>
        </div>
      </div>
    </curtains>
  </div>
</template>
<script>
    import Navigation from '../components/common/Navigation.vue';
    import Curtains from '../components/common/CurtainsTest';
    import fixedBlocks from '../components/common/fixedBlocks';
    import fixedBlocksMobile from '../components/common/fixedBlocksMobile';

    export default {
        name: "Test",
        metaInfo: {
            title: 'Тест',
        },
        components: {
            Navigation,
            Curtains,
            fixedBlocks,
            fixedBlocksMobile
        },
        mounted: function () {
            this.$ga.event('Тест', 'Начало теста', 1);
            this.$ga.event('Тест', 'Просмотр вопроса №' + this.current, 1);
        },
        data() {
            return {
                state: 'test',
                current: 1,
                questions: [
                    {
                        index: 1,
                        text: "Начнем с главного для болельщика: что предпочитаете есть во время просмотра матча?",
                        score: 0,
                        image: require("../assets/images/test/вопрос_1.png"),
                        variants: [
                            {
                                text: "Что-нибудь простое и ненавязчивое: сковородку колбасок, огромную соленую рыбину.",
                                score: 3,
                            },
                            {
                                text: "Ничего! Не могу отвлекаться на еду во время просмотра, так переживаю за итоговый счет.",
                                score: 4,
                            },
                            {
                                text: "Бабушкины пирожки.",
                                score: 2,
                            },
                            {
                                text: "Да что-нибудь стандартное: например, треску под пеной из черной фасоли с ферментированными корнеплодами.",
                                score: 1,
                            },
                        ]
                    },
                    {
                        index: 2,
                        text: "Болельщики во всем мире предпочитают один хорошо всем знакомый напиток. Но что будете делать, если его-то как раз в холодильнике не окажется? Чем замените на время просмотра матча?",
                        score: 0,
                        image: require("../assets/images/test/вопрос_2.png"),

                        variants: [
                            {
                                text: "Квасом.",
                                score: 2,
                            },
                            {
                                text: "Кофе.",
                                score: 3,
                            },
                            {
                                text: "Колой.",
                                score: 4,
                            },
                            {
                                text: "Морсом из морошки.",
                                score: 1,
                            },
                        ]
                    },
                    {
                        index: 3,
                        text: "Теперь проверим, насколько вы темпераментны как болельщик. Представьте, что во время трансляции важного матча у вас ломается телевизор, — ваши действия?",
                        score: 0,
                        image: require("../assets/images/test/вопрос_3.png"),
                        variants: [
                            {
                                text: "Ничего страшного: включу другой телевизор — я его специально купил как раз для таких случаев.",
                                score: 3,
                            },
                            {
                                text: "Выскочу на лестничную площадку, позвоню в ближайшую дверь и буду умолять соседа пустить меня к нему досмотреть матч.",
                                score: 4,
                            },
                            {
                                text: "Открою компьютер и погружусь в увлекательный мир форумов любителей радиоэлектроники, чтобы узнать, как починить сломавшийся телевизор.",
                                score: 1,
                            },
                            {
                                text: "Найду трансляцию матча в интернете.",
                                score: 2,
                            },
                        ]
                    },
                    {
                        index: 4,
                        text: "А на что вы вообще готовы ради любимой команды? Важнейший матч нашей сборной выпадает на день рождения вашего любимого человека. Жуткая ситуация, что делать-то?",
                        score: 0,
                        image: require("../assets/images/test/вопрос_4.png"),
                        variants: [
                            {
                                text: "Все просто: с этого момента у меня в фейсбуке появляется статус «Ни с кем не встречаюсь».",
                                score: 4,
                            },
                            {
                                text: "Как можно думать о матче в такой день? Организую свидание, которое, правда, совершенно случайно состоится в спортбаре.",
                                score: 3,

                            },
                            {
                                text: "Отключу телефон и останусь дома — болеть за наших!",
                                score: 2,
                            },
                            {
                                text: "Попробую объяснить любимому человеку, что день рождения — раз в году, а действительно важные матчи у нашей сборной случаются намного реже. ",
                                score: 1,

                            },
                        ]
                    },
                    {
                        index: 5,
                        text: "Так, за любимую команду вы болеете — а вы точно настоящий и страстный фанат, который хорошо знает правила игры? Вот за что игрока могут удалить с поля?",
                        score: 0,
                        image: require("../assets/images/test/вопрос_5.png"),
                        variants: [
                            {
                                text: "В игре удаляют вратаря, если тот пропускает более трех мячей за игру. ",
                                score: 1,

                            },
                            {
                                text: "За использование на поле смартфона с неотключенным звуком.",
                                score: 2,

                            },
                            {
                                text: "За многое: очень грубую игру, драку, хамство по отношению к игрокам, судье и даже зрителям. ",
                                score: 4,

                            },
                            {
                                text: "Во время матча не удаляют игроков с поля: их просто сажают в штрафной бокс на две минуты, а затем они могут вернуться в игру.",
                                score: 3,

                            },
                        ]
                    },

                    {
                        index: 6,
                        text: "А сколько раз в своей новейшей истории сборная России играла в финалах международных соревнований? ",
                        score: 0,
                        image: require("../assets/images/test/вопрос_6.png"),
                        variants: [
                            {
                                text: "В прошлом году, точно помню! Или это я с хоккеем путаю?",
                                score: 1,

                            },
                            {
                                text: "Э… раза два или три, не больше, не очень-то сильная у нас сборная.",
                                score: 2,

                            },
                            {
                                text: "Ну разок-то точно сыграла — лет десять назад, у нас просто после народных гуляний по этому поводу до сих пор не все стекла в подъезде вставили.",
                                score: 3,

                            },
                            {
                                text: "Следующий вопрос.",
                                score: 4,

                            },
                        ]
                    },

                    {
                        index: 7,
                        text: "Каждый человек по-разному ведет себя на трибуне стадиона — вот как вы гол в ворота соперников празднуете?",
                        score: 0,
                        image: require("../assets/images/test/вопрос_7.png"),
                        variants: [
                            {
                                text: "Ну что ж, молодцы, думаю я после забитого мяча, но скорей бы все вокруг сели на свои места и перестали орать.",
                                score: 2,

                            },
                            {
                                text: "Смотрю на табло, кто забил, после чего снова продолжаю читать книгу или просматривать ленту друзей в инстаграме.",
                                score: 1,

                            },
                            {
                                text: "Вскакиваю с места, аплодирую и, если удастся, обнимаю красивую незнакомку как бы случайно — от нахлынувших эмоций.",
                                score: 3,

                            },
                            {
                                text: "Улетаю вниз по трибуне на несколько рядов вниз, в полете традиционно теряю телефон и ключи от дома — зато чувствую при этом себя самым счастливым человеком на земле.",
                                score: 4,

                            },
                        ]
                    },
                    {
                        index: 8,
                        text: "Какой способ поддержки любимой команды вызывает у вас наибольшую симпатию?",
                        score: 0,
                        image: require("../assets/images/test/вопрос_8.png"),
                        variants: [
                            {
                                text: "Хоровое пение на протяжении всей игры, красивый развес национальных флагов.",
                                score: 3,

                            },
                            {
                                text: "Дым, огонь, слэм, все на ногах весь матч и ни на секунду не замолкают, включая стариков.",
                                score: 4,

                            },
                            {
                                text: "Ну баннер огромный и красивый в начале матча растянуть на стадионе, а затем просто сосредоточиться на самой игре.",
                                score: 2,

                            },
                            {
                                text: "Похлопать после забитого мяча всей трибуной, да и хватит, пожалуй, лишний шум наверняка только мешает игре.",
                                score: 1,

                            },
                        ]
                    }, {
                        index: 9,
                        text: "Только что завершился драматичный матч любимой команды, в котором она одержала историческую победу, вы видели ее своими глазами. После такой игры чем займетесь?",
                        score: 0,
                        image: require("../assets/images/test/вопрос_9.png"),
                        variants: [
                            {
                                text: "Поеду домой на метро. Я со стадиона ухожу всегда минут за пятнадцать до конца игры, чтобы не терять времени на выход и избежать давки. ",
                                score: 2,

                            },
                            {
                                text: "Порадуюсь, что наконец-то игра закончилась, а значит, сейчас начнется мое любимое кулинарное шоу по ТВ. Делать мне больше нечего, как на стадионе матч смотреть, если дома есть телевизор.",
                                score: 1,

                            },
                            {
                                text: "Не смогу сразу поехать домой, постою еще часок-другой у стадиона, обсуждая с возбужденными болельщиками все перипетии этой исторической игры.",
                                score: 3,

                            },
                            {
                                text: "Поеду на центральную площадь города, где вместе с другими болельщиками буду купаться в фонтанах, кататься на крышах автобуса и распевать гимн страны, пока голос окончательно не сядет.",
                                score: 4,

                            },
                        ]
                    },
                    {
                        index: 10,
                        text: "И последнее: представьте невероятную ситуацию — сборная России на международных соревнованиях выбывает еще до финального матча. Какой сборной пожелаете победы в турнире?",
                        score: 0,
                        image: require("../assets/images/test/вопрос_10.png"),
                        variants: [
                            {
                                text: "Бразилии.",
                                score: 4,

                            },
                            {
                                text: "Англии.",
                                score: 3,

                            },
                            {
                                text: "Все равно России!",
                                score: 2,

                            },
                            {
                                text: "Японии.",
                                score: 1,

                            },
                        ]
                    }

                ],
                results: [
                    {
                        index: 1,
                        image: require("../assets/images/test/тип_1.png"),
                        title: 'Вы — дзен!',
                        text: 'Вы спокойны и созерцательны, как болельщики сборной Японии. Ничто не должно нарушать тишину и спокойствие вокруг — даже решающий гол вашей сборной на последней секунде матча. ',
                        shareTitle: 'Я — дзен!',
                        shareText: 'Ничто не должно нарушать тишину и спокойствие вокруг — даже решающий гол моей сборной на последней секунде матча. ',
                    },
                    {
                        index: 2,
                        image: require("../assets/images/test/тип_2.png"),

                        title: 'Вы — наш человек!',
                        text: 'Вы темпераментны, но в меру. А все оттого, что привыкли к типичной игре нашей сборной, поэтому и не тратите много нервов и эмоций, наблюдая за ней. ',
                        shareTitle: 'Наш человек! ',
                        shareText: 'Я привык к типичной игре нашей сборной, поэтому и не трачу много нервов и эмоций, наблюдая за ней. ',
                    },
                    {
                        index: 3,
                        image: require("../assets/images/test/тип_3.png"),

                        title: 'Вы — гость из Туманного Альбиона.',
                        text: 'Британский стиль боления — ваша стихия: много шума, крика, но при этом вы запросто можете предпочесть матчу любимой команды поход в кино или ресторан.',
                        shareTitle: 'Я — гость из Туманного Альбиона. ',
                        shareText: 'Британский стиль боления — моя стихия: много шума, крика, но при этом я запросто могу предпочесть матчу любимой команды поход в кино или ресторан.',
                    },
                    {
                        index: 4,
                        image: require("../assets/images/test/тип_4.png"),

                        title: 'Вы — сама страсть!',
                        text: 'Вам трудно понять, как можно смотреть матч так, чтобы об этом не узнали все ваши соседи по дому. Словом, ведете себя перед телевизором или на стадионе как самые горячие в мире болельщики из Южной Америки.',
                        shareTitle: 'Я — сама страсть! ',
                        shareText: 'Покажи, как ты болеешь за любимую команду и получи шанс выиграть гастротур на двоих в Бразилию! ',
                    },
                ],
                resultIndex: 1
            }
        },
        computed: {
            totalScore() {
                let score = 0;
                for (let question of this.questions) {
                    score += question.score;
                }
                return score;
            }
        },
        methods: {
            nextQuestion() {
                if (this.current >= 10) {
                    this.result()
                } else {
                    this.current++;
                }
                this.$ga.event('Тест', 'Просмотр вопроса №' + this.current, 1);


            },
            prevQuestion() {
                if (this.current >= 2) {
                    this.current--;
                }
                this.$ga.event('Тест', 'Просмотр вопроса №' + this.current, 1);

            },
            result() {
                let score = this.totalScore;
                if (score < 15) {
                    this.resultIndex = 1
                }
                if (score >= 15 && score < 20) {
                    this.resultIndex = 2
                }
                if (score >= 20 && score < 30) {
                    this.resultIndex = 3
                }
                if (score >= 30 && score <= 40) {
                    this.resultIndex = 4
                }
                this.$ga.event('Тест', 'Пройден тест: ' + this.results[this.resultIndex - 1].title, 1);

                this.state = 'result';


            }
        }
    }
</script>
<style scoped lang="scss">
  .page {
    background-color: #0d8987;
  }

  .questions {
    display: flex;
    align-items: center;
    width: 86%;
    margin: 0 auto;
    position: relative;
    z-index: 210;
    padding-top: 25px;
    min-height: calc(87vh - 24px);
    padding-bottom: 7vh;
    .block {
      width: 50%;
      overflow: hidden;
    }
  }

  .question {
    overflow: hidden;
    .title {
      font-size: 20px;
      font-weight: 400;
      line-height: 28px;
      text-align: left;
    }
  }

  .image-block {
    display: flex;
    align-items: center;
    justify-content: center;
    .image-container {
      background-image: url("../assets/images/test/ellipse.png");
      background-repeat: no-repeat;
      background-position: bottom center;
      background-size: 75% 75%;
      overflow: hidden;
      img {
        max-width: 80%;
        max-height: 80vh;
      }
    }

  }

  .counter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 244px;
    margin-top: 40px;

    .c_line {
      display: block;
      background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='91px' height='4px'%3e%3cpath fill-rule='evenodd' fill='rgb(255, 255, 255)' d='M2.000,-0.000 L89.000,-0.000 C90.104,-0.000 91.000,0.896 91.000,2.000 C91.000,3.105 90.104,4.000 89.000,4.000 L2.000,4.000 C0.895,4.000 -0.001,3.105 -0.001,2.000 C-0.001,0.896 0.895,-0.000 2.000,-0.000 Z'/%3e%3c/svg%3e");
      width: 91px;
      height: 4px;
      background-repeat: no-repeat;
    }
    .number {
      font-size: 24px;
      font-weight: 400;
      line-height: 20px;
      text-align: center;
      overflow: hidden;
      padding: 18px;
      &.active {
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='43px' height='42px'%3e%3cdefs%3e%3clinearGradient id='PSgrad_0' x1='0%25' x2='0%25' y1='100%25' y2='0%25'%3e%3cstop offset='0%25' stop-color='rgb(216,16,128)' stop-opacity='1' /%3e%3c/linearGradient%3e%3c/defs%3e%3cpath fill-rule='evenodd' fill='url(%23PSgrad_0)' d='M21.014,0.000 C31.757,0.000 42.022,10.261 42.022,21.000 C42.022,31.738 30.200,42.000 19.457,42.000 C8.713,42.000 0.004,33.295 0.004,22.556 C0.004,11.817 10.270,0.000 21.014,0.000 Z'/%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: center center;

      }
    }
  }

  .answers {
    overflow: hidden;
    padding-left: 40px;
    padding-right: 10px;
  }

  .answer {
    display: block;
    position: relative;
    padding-left: 60px;
    margin-bottom: 3.5vh;
    cursor: pointer;
    font-size: 22px;
    user-select: none;
    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }
    .text {
      font-size: 16px; /* Приближение из-за подстановки шрифтов */
      font-weight: 400;
      line-height: 20px; /* Приближение из-за подстановки шрифтов */
      text-align: left;
      display: block;
    }
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 30px;
    width: 30px;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='53px' height='53px'%3e%3cpath fill-rule='evenodd' stroke='rgb(255, 255, 255)' stroke-width='2px' stroke-linecap='butt' stroke-linejoin='miter' fill='none' d='M25.990,1.000 C38.767,1.000 50.975,13.216 50.975,26.000 C50.975,38.785 36.915,51.000 24.140,51.000 C11.363,51.000 1.005,40.635 1.005,27.851 C1.005,15.067 13.213,1.000 25.990,1.000 Z'/%3e%3c/svg%3e");
    background-size: cover;
    background-repeat: no-repeat;
  }

  .answer {

    input:checked ~ .checkmark {
    }
  }

  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  .answer {
    &:hover {
      opacity: 0.9;
      /*transform: scale(1.005);*/
      input ~ .checkmark:after {
        display: block;
        opacity: 0.5;
      }
    }
    input:checked ~ .checkmark:after {
      display: block;
    }
    .checkmark:after {
      top: 5px;
      left: 4px;
      width: 20px;
      height: 20px;
      background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='34px' height='34px'%3e%3cdefs%3e%3clinearGradient id='PSgrad_0' x1='0%25' x2='0%25' y1='100%25' y2='0%25'%3e%3cstop offset='0%25' stop-color='rgb(216,16,128)' stop-opacity='1' /%3e%3c/linearGradient%3e%3c/defs%3e%3cpath fill-rule='evenodd' fill='url(%23PSgrad_0)' d='M16.985,0.332 C25.503,0.332 33.642,8.477 33.642,17.000 C33.642,25.524 24.269,33.667 15.751,33.667 C7.233,33.667 0.328,26.757 0.328,18.234 C0.328,9.712 8.467,0.332 16.985,0.332 Z'/%3e%3c/svg%3e");
      background-repeat: no-repeat;
      background-size: cover;
    }
  }

  .prevQuestionLink {
    color: white;
    font-size: 16px; /* Приближение из-за подстановки шрифтов */
    font-weight: 300;
    line-height: 40px; /* Приближение из-за подстановки шрифтов */
    text-decoration: underline;
    text-align: left;
    position: fixed;
    top: 65px;
    left: 45px;
    z-index: 300;
    cursor: pointer;

  }

  .result {
    overflow: hidden;

    .title {
      font-size: 30px;
      font-weight: 700;
      text-align: left;
    }
    .text {
      font-size: 16px;
      text-align: left;
      line-height: 20px;
    }
    a {
      font-size: 14px;
      color: white;
      text-align: left;
      display: block;
    }
  }

  .share-links {
    display: flex;
    width: 110px;
    justify-content: space-between;
  }

  .share-result {
    display: flex;
    align-items: center;
  }

  .shares-links {
    display: inline-flex;
    margin-left: 10px;
    .icon {
      width: 25px !important;
      height: 25px !important;
    }
  }

  @media screen and (max-width: 769px) {
    .questions {
      flex-direction: column;
      margin-top: 10vh;
      z-index: 199;
      padding-bottom: 90px;
      .block{
        width: 95%;
      }
    }
    .question {
      .title {
        font-size: 16px;
        line-height: 20px;
      }
    }
    .answers {
      padding: 1vmin;
    }
    .answer {
      padding-left: 40px;
      margin-bottom: 5vmin;
      .text {
        font-size: 14px;
        line-height: 20px;
      }
    }
    .image-block {
      max-width: 60vmin;
      max-height: 60vmin;
    }
    .counter {
      margin: 0;
    }
    .prevQuestionLink {
      position: absolute;
      top: 33px;
      left: 22px;
    }
    .share-result {
      flex-direction: column;
      align-items: flex-start;
    }
    .shares-links {
      margin: 10px;
      margin-left: 0;
    }
  }


</style>
